import { useRootPath } from 'hooks/useLayout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CreateButtonStyles } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

export default function CreateButton({
  isCreateModal,
  customRootPath,
}: {
  isCreateModal?: boolean;
  customRootPath?: string;
}) {
  const navigate = useNavigate();
  const rootPath = useRootPath();
  const { t } = useTranslation();

  const onAdd = (() => {
    const _routePath = customRootPath || rootPath
    
    navigate(isCreateModal ? `#${_routePath}/create` : `/${_routePath}/create`);
  });

  // const onAdd = useCallback(() => {
  //   navigate(isCreateModal ? `#${rootPath}/create` : `${path}create`);
  // }, [rootPath, isCreateModal]);

  return (
    <CreateButtonStyles onClick={onAdd} type="primary">
      <FontAwesomeIcon icon={faPlus} />
      {t('button.create')}
    </CreateButtonStyles>
  );
}
